import { css, type Theme } from "@emotion/react";

export const badge = (theme: Theme) => css`
  position: absolute;
  top: 8px;
  right: -${theme.ds5.gap[200]};
  transform: translateY(-50%);
  pointer-events: none;
  white-space: nowrap;
`;

export const container = css`
  position: relative;
  display: block;
  width: 100%;
`;
